import { ROTULO_STATUS, type StatusCotacao } from '@profitlens/dominio';

/**
 * Selo de status da cotacao.
 *
 * EXPIRADA nunca e gravada em campo nenhum: ela e derivada da validade na hora
 * da leitura (RN-041). Foi essa observacao que dispensou a tarefa de madrugada
 * — e o motivo de este selo receber o status JA efetivo, nao o status cru.
 */
const CORES: Record<StatusCotacao, string> = {
  RASCUNHO: 'text-tinta-3 bg-tinta-3/12',
  AGUARDANDO_APROVACAO: 'text-c-res bg-c-res/12',
  ENVIADA: 'text-est bg-est/12',
  RESPONDIDA: 'text-c-via bg-c-via/12',
  PARCIALMENTE_RESPONDIDA: 'text-c-res bg-c-res/12',
  NECESSITA_REVISAO: 'text-c-mar bg-c-mar/12',
  EXPIRADA: 'text-c-dad bg-c-dad/12',
  CANCELADA: 'text-tinta-3 bg-tinta-3/12',
};

const EXPLICACAO: Partial<Record<StatusCotacao, string>> = {
  EXPIRADA: 'A validade passou. Não alimenta análise nova, mas continua consultável (RN-042).',
  PARCIALMENTE_RESPONDIDA: 'Parte dos itens já tem resposta (RN-043).',
  NECESSITA_REVISAO: 'Algum dado precisa de conferência antes de virar análise.',
};

export function SeloCotacao({ status }: { status: StatusCotacao }) {
  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-0.5 font-mono text-[0.65rem] font-semibold tracking-wide uppercase ${CORES[status]}`}
      title={EXPLICACAO[status]}
    >
      {ROTULO_STATUS[status]}
    </span>
  );
}
